import React from "react";
import {
  Modal,
  IconButton,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import { StyledButton } from "../buttons/custom-button";
import {
  StyledModal,
  ModalContainer,
  CloseButton,
  FooterContainer,
} from "./custom-popup";

export interface ActionButtonConfig {
  label: string;
  onClick: () => void;
  variant?: "text" | "outlined" | "contained";
  color?: "inherit" | "primary" | "secondary" | "default";
  disabled?: boolean;
  isLoading?: boolean;
}

interface ModalPopupProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  actions?: ActionButtonConfig[];
  // Add these new optional props
  maxWidth?: string;
  minHeight?: string;
  maxHeight?: string;
  width?: string;
}

const ActionsModalPopup: React.FC<ModalPopupProps> = ({
  open,
  onClose,
  title,
  children,
  actions = [],
  maxWidth = '90%',
  minHeight = '80%',
  maxHeight = '80%',
  width = '60%',
}) => {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      role="dialog"
    >
      <ModalContainer
        sx={{
          maxWidth,
          minHeight,
          maxHeight,
          width,
        }}
      >
        <CloseButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </CloseButton>

        {title && (
          <Typography variant="h6" id="modal-title" gutterBottom>
            {title}
          </Typography>
        )}

        <Box flex="1">{children}</Box>

        <FooterContainer>
          {actions.map((action, index) => (
            <StyledButton
              key={index}
              onClick={action.onClick}
              variant={action.variant || "text"}
              disabled={action.disabled}
            >
              {action?.isLoading ? (
                <Box
                  className="loading-indicator"
                  display="flex"
                  alignItems="center"
                >
                  <CircularProgress size={20} color="inherit" />
                </Box>
              ) : (
                <> {action.label}</>
              )}
            </StyledButton>
          ))}
        </FooterContainer>
      </ModalContainer>
    </StyledModal>
  );
};

export default ActionsModalPopup;
